module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('div', {
    staticClass: "items"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      class: {
        'selected': _vm.selectedItem === item.slug
      },
      on: {
        "click": function($event) {
          return _vm.handleClick(item.slug)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [(_vm.counts[item.slug] !== null && _vm.counts[item.slug] !== '-') ? _c('div', {
      staticClass: "count"
    }, [(_vm.counts[item.slug] !== null || _vm.counts[item.slug] !== '-') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.counts[item.slug]) + "\n                    ")]) : _vm._e()]) : (_vm.counts[item.slug] === '-') ? _c('div', {
      staticClass: "count"
    }, [_c('span', [_vm._v("\n                        -\n                    ")])]) : _c('div', {
      staticClass: "count"
    }, [_c('i', {
      staticClass: "fal fa-spinner fa-spin"
    })]), _vm._v(" "), (item.comingsoon) ? _c('div', {
      staticClass: "coming-soon"
    }, [_vm._v("\n                    Kommer snart\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                    "), (item.dTooltip) ? _c('d-tooltip', {
      attrs: {
        "placement": "inline",
        "identifier": item.dTooltip
      }
    }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedItem === item.slug) ? _c('div', {
      staticClass: "icon"
    }, [_c('svg', {
      attrs: {
        "width": "600px",
        "height": "300px",
        "viewBox": "0 0 600 300",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('g', {
      attrs: {
        "id": "Page-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('polygon', {
      attrs: {
        "id": "Rectangle",
        "fill": "#D8D8D8",
        "points": "0 0 600 0 300 300"
      }
    })])])]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25425858"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/contentSwitch.vue
// module id = 826
// module chunks = 0